import { Button } from 'antd';
import { RootObject, ScienceBannerJumpContent } from '../../type';
import './style.less';

const ScienceBanner = (props: RootObject["scienceBanner"]) => {
  return (
    <div className="science_banner">
      <div className="science_banner_wrapper">
        {/* 文案信息 */}
        <div className="banner_info">
          <div className="banner_title">
            {props.scienceBannerTitle ?? ""}
          </div>
          <div className="banner_content">
            {props.scienceBannerContent ?? ""}
          </div>
          <div className="banner_jump">
            {
              props?.scienceBannerJumpContent?.map((value: ScienceBannerJumpContent, index: number) => {
                if (index === 0) {
                  return (
                    <Button className="banner_btn" type='primary' key={index}>
                    <a href={value.detailLink}>{value.title ?? ""}</a>
                  </Button>
                  )
                }
                if (index === 1) {
                  return (
                    <Button className="banner_btn" key={index}>
                    <a href={value.detailLink}>{value.title ?? ""}</a>
                  </Button>
                  )
                }
                return (<></>)
              })
            }
          </div>
        </div>
        {/* 图片 */}
        <img className="banner_img" src={props.bannerImg} alt=""></img>
      </div>
    </div>
  )
};

export default ScienceBanner;